import { Field, Flex } from '@chakra-ui/react'
import _ from 'lodash'
import { useMemo } from 'react'
import { useBoolean } from 'react-use'
import { Button } from 'uikit'
import { useColorMode } from 'uikit/ColorMode/ColorMode'
import { ImageCropper } from '../ImageCropper'
import empty from './empty-image.svg'

export const FormUploadImage = ({
  field,
  form,
  label,
  isLoading,
  isCropRequired,
  optionsCompress,
  optionsCropper,
  optionsCroppedCanvas,
  colorPalette = 'blue',
  ...props
}) => {
  const { colorMode } = useColorMode()
  const [isOpen, setIsOpen] = useBoolean(false)
  const errorColor = colorMode === 'light' ? '#E53E3E' : '#fc8181'
  const isInvalid = _.get(form.errors, field.name) && _.get(form.touched, field.name)
  const error = _.get(form.errors, field.name)

  const value = useMemo(() => {
    if (field.value !== '') {
      return JSON.parse(field.value)
    }
    return {
      name: '',
      uri: '',
      type: '',
    }
  }, [field.value])

  const handleChange = (e) => {
    form.setFieldValue(field.name, JSON.stringify(e))
  }

  return (
    <>
      <Field.Root>
        {label && <Field.Label>{label}</Field.Label>}
        <Flex
          w="full"
          alignItems="center"
          borderRadius={6}
          borderWidth={1}
          padding="16px 20px"
          {...field}
          {...props}
          {...(error &&
            isInvalid && {
              borderColor: errorColor,
              boxShadow: `0 0 0 1px ${errorColor}`,
            })}
        >
          <Flex
            width="100px"
            height="100px"
            name="F"
            marginRight={6}
            borderRadius="8px"
            overflow="hidden"
            backgroundImage={`url(${empty})`}
          >
            {value.uri !== '' && (
              <Flex
                flex={1}
                backgroundImage={`url(${value.uri})`}
                backgroundSize="contain"
                backgroundRepeat="no-repeat"
                backgroundPosition="center"
              />
            )}
          </Flex>
          <Button variant="outline" onClick={() => setIsOpen(true)} loading={isLoading} size="sm">
            Выбрать
          </Button>
        </Flex>
      </Field.Root>
      <ImageCropper
        colorPalette={colorPalette}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        file={value}
        isCropRequired={isCropRequired}
        onChange={handleChange}
        optionsCompress={optionsCompress}
        optionsCropper={optionsCropper}
        optionsCroppedCanvas={optionsCroppedCanvas}
      />
    </>
  )
}
